/**
 * Fire/skip decision for the silent reload at the route boundary
 * (MEIS-13220, design.md D5). The wiring hook (`DeployCompatibility.tsx`)
 * owns the `armed` flag and disarms it immediately after a fire, so "at
 * most once per armed update" is satisfied by the caller, not by state kept
 * in this module.
 */
export interface RouteBoundaryReloadDecisionInput {
  /** A compatible update was detected and not yet consumed by a reload. */
  armed: boolean;
  /** `document.querySelector(".MuiDialog-root") !== null` heuristic. */
  isMuiDialogOpen: boolean;
  /** Result of the shared reload guard (`canAutoReload()`). */
  guardAllows: boolean;
}

export function shouldReloadAtRouteBoundary(
  input: RouteBoundaryReloadDecisionInput
): boolean {
  return input.armed && !input.isMuiDialogOpen && input.guardAllows;
}
